import functions from "./functions";
import axios from "axios";
var processComments = {
  async getWithPagination(page, pageSize, sort, sortDesc, processId) {
    const start = Date.now();

    var filters = {};

    if (processId) {
      filters = {
        process: {
          id: { eq: processId },
        },
      };
    }

    var query = `query processComments($filters:ProcessCommentFiltersInput){
        processComments( sort:"${sort}${
      sortDesc ? ":desc" : ""
    }" filters:$filters ,pagination:{page:${page},pageSize:${pageSize}}){
            data{
              id
              attributes{
                createdAt
                value
                title
                user{
                  data{
                    id
                    attributes{
                      username
                    }
                  }
                }
              }
            }
        }
      }
    `;
    var graphql = JSON.stringify({
      query,
      variables: {
        filters,
      },
    });
    var url = `${process.env.VUE_APP_STRAPI_URL}/graphql`;
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: graphql,
    })
      .then((res) => {
        if (window.debug) console.log(res);
        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log(json);
        return json;
      });

    const end = Date.now();
    if (window.debug)
      console.log(
        `Execution getWithPagination processComments time: ${
          (end - start) / 1000
        } s`
      );

    const pagination = res?.data?.processComments?.meta?.pagination;
    const values = functions.sanitize(res.data.processComments.data);
    return { values, pagination };
  },

  async post(comment) {
    try {
      let ans = await axios.post(
        `${process.env.VUE_APP_STRAPI_URL}/api/process-comments`,
        {
          data: comment,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        }
      );
      return ans;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        const { status, statusText, data } = error.response;
        if (data?.errors)
          throw new Error(data?.errors.map((el) => el.message)?.join(",")); // Rethrow or handle the error
        if (data?.error) throw new Error(data?.error.message); // Rethrow or handle the error
      } else if (error.request) {
        throw new Error("No response from the server.");
      } else {
        throw new Error("An error occurred while setting up the request.");
      }
    }
  },
};

export default processComments;
